import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  ADMIN_AVAILABLE_PAYMENT_SYSTEMS_ROUTE_NAME,
} from '../../constants';
import {
  ADMIN_GENERAL_SETTINGS_PAYMENT_COUNTRY_GROUPS_UPDATE_ROUTE_NAME,
  TRANSLATION_GROUP_GENERAL_SETTINGS_PAYMENT_COUNTRY_GROUPS,
} from './constants';
import { getTranslationKeys } from './translations';

export class AdminPaymentCountryGroupsModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_AVAILABLE_PAYMENT_SYSTEMS_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_PAYMENT_COUNTRY_GROUPS_UPDATE_ROUTE_NAME,
      path: 'settings/:id?',
      meta: {
        hideParentModuleWrapper: true,
      },
      component: () => import('./pages/PaymentCountryGroupsFormPage/PaymentCountryGroupsFormPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_GENERAL_SETTINGS_PAYMENT_COUNTRY_GROUPS, getTranslationKeys);
  }
}
